import { render, staticRenderFns } from "./OrderStatesDonutChart.vue?vue&type=template&id=5881793e&"
import script from "./OrderStatesDonutChart.vue?vue&type=script&lang=js&"
export * from "./OrderStatesDonutChart.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatesDonutChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports